import { UserService } from '../user/user.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { StatusAgentsComponent } from './status-agents.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ChartsModule } from 'ng2-charts';
import { DxChartModule } from 'devextreme-angular';
import { DxPieChartModule } from 'devextreme-angular';

import { StatusAgentsRoutingModule } from './status-agents-routing.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatIconModule } from "@angular/material/icon";

//multiselect
import { AngularMultiSelectModule } from 'angular4-multiselect-dropdown/angular4-multiselect-dropdown';


@NgModule({
  imports: [
    CommonModule, 
    StatusAgentsRoutingModule, 
    ModalModule.forRoot(),
    SharedModule,
    FormsModule,
    AngularMultiSelectModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    MatIconModule,
    ChartsModule,
    DxChartModule,
    DxPieChartModule,
    NgMultiSelectDropDownModule.forRoot()

  ],
  declarations: [
    StatusAgentsComponent
  ],
  providers:[
    NgxSpinnerService,
    DashboardService,
    DatePipe,
    UserService
  ]
})
export class StatusAgentsModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/status-agents/status-agents.module.ts